/**
 * NIGHTBOUND - shared navigation model.
 *
 * The locked destinations are present from the start so the map of the game is
 * visible to the player before the systems exist behind them.
 */

export interface NavItem {
  to: string
  label: string
  /** Full label used in the desktop rail. */
  short: string
  glyph: string
  /** Shown as "soon" - the destination exists but its systems are not built. */
  locked?: boolean
}

export const GAME_NAV: NavItem[] = [
  { to: '/shelter', label: 'Shelter', short: 'Shelter', glyph: '⌂' },
  { to: '/inventory', label: 'Stores', short: 'Stores', glyph: '❖' },
  { to: '/adventure', label: 'Adventure', short: 'Adventure', glyph: '♜', locked: true },
  { to: '/pit', label: 'The Pit', short: 'The Pit', glyph: '⚔', locked: true },
  { to: '/settings', label: 'Settings', short: 'Settings', glyph: '⚙' },
]
